import { defineComponent } from "vue";
import { VueContext } from "../../types";
import { createAppWithRootComponent, VueEmit } from "../core/vueHelpers";
import BreadCrumbComponent from "./breadcrumb";
import * as Classes from "./classes";
import { ServerBreadcrumb } from "./types";


const breadcrumbContainerClasses =
{
    [Classes.breadcrumbList]: true,
    [Classes.jsbreadcrumbList]: true
}

const BreadCrumbContainerComponent = defineComponent(
{
    name: "treebrowseBreadcrumbContainer",
    props: {},
    emits:
    {
        browseBack: VueEmit<(index: number, crumb: ServerBreadcrumb) => boolean>()
    },
    data()
    {
        const initialData =
        {
            breadcrumbs: [] as ServerBreadcrumb[]
        };
        return initialData;
    },
    methods:
    {
        __handleCrumbClick(index: number)
        {
            this.$emit('browseBack', index, this.breadcrumbs[index]);
        }
    },
    render()
    {
        const listElements = this.breadcrumbs.map((crumb, index) =>
        {
            const style = { 'margin-left': index * 5 + 'px' };

            const component = <BreadCrumbComponent
                moduleName={crumb.moduleName}
                objectName={crumb.objectName}
                positionObjectPath={crumb.positionObjectPath}
                displayName={crumb.displayName}
                isOneToMany={crumb.isOneToMany ?? false}
                index={index}
                onBreadcrumbClicked={(index: number) => this.__handleCrumbClick(index)}
            />;

            return <li style={style}>
                {component}
            </li>
        });
        
        return <ul class={breadcrumbContainerClasses}>
            {listElements}
          </ul>
    },
}); 

export const BreadcrumbContainer =
{
    buildVue(context: BreadCrumbContainerContext)
    {
        const app = createAppWithRootComponent(BreadCrumbContainerComponent, context.props);
        return app.mount(context.container);
    }
};

interface BreadCrumbContainerContext extends VueContext
{
    props:
    {
        onBrowseBack: (index: number, crumb: ServerBreadcrumb) => void;
    },
}
